import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import { map, startWith } from "rxjs/operators";
import swal from "sweetalert2";
import { GrnService } from "../../../services/grn.service";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  SampleService,
} from "../../../services/index";
//import { PurchaseEvents } from './PurchaseEvents';
import { PurchaseOrderService } from "../../../services/purchaseorder.service";

@Component({
  selector: "AddEditcreateSample",
  templateUrl: "./AddEditcreateSample.html",
})
export class AddEditcreateSample {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: "0", totalamt: "0" };
  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeTypeListExists: any = [];
  purchaseAgentList = [];
  seasonList = [];
  checklist = [];
  detailpreList = [];
  seriesLimitsList: any[] = [];
  seriesLimitsLoading = false;
  seriesSearch = '';
  detailList: any = [];
  filter: any = {
    season: "",
    dc_no: "",
    date: "",
    ref_no: "",
  };
  shirtArr = {};
  sampleArr = {};
  fullSeries = [];
  samplePrefixList = [
    {
      style: "FORMAL",
      prefix: "FL-",
    },
    {
      style: "CASUAL",
      prefix: "CL-",
    },
    {
      style: "STYLISH FORMAL",
      prefix: "SF-",
    },
    {
      style: "CLUB WEAR",
      prefix: "CW-",
    },
  ];
  varietyList = [];
  varietyList1 = [];
  styleList1: any;
  shirtStyle = ["FORMAL", "CASUAL","RR FORMAL","RR CASUAL", "CLUBWEAR", "CLUB"];
  brandList = ["EXPOSE", "ARAZA", "OLIVE", "JOB"];

  colorTypeList: any = [];
  editShadeOpen: boolean = false;
  colorList: any;
  codeList: any = [];
  shadeType = "";
  shadeColor = "";
  widthList: any[];
  designTypeList = ["NEW", "CORE", "GANG"];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
    Is_save : boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.designdata = designdata;
    if (this.mode == "Edit" || this.mode == "View") {
      // this.designdata.po_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.designdata.party_name = designdata.party_name;
      this.designdata.date = designdata.date;
      if (this.mode == "Edit") {
        this.filter.date = designdata.date;
        this.filter.ref_no = designdata.ref_no;
        this.filter.dc_no = designdata.dc_no;
        this.filter.season = designdata.cur_season;
        this.filter.sam_id = designdata.sam_id;

        this.loadeditdesignlist(designdata.sam_id);
      }
      // this.loadeditdesignlist();
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    private grn: GrnService,
    private sampService: SampleService,
    private comboservice: ComboService,
    private poservice: PurchaseOrderService
  ) {
    //   $('#modalCart').modal({
    //     show: false
    //  });
    // this.row = {
    //   design_type: "NEW",
    //   design_no: "",
    //   shade: "",
    //   fabric_design: "",
    //   style: "",
    //   shirt_style: "",
    //   // fabric_shade: "",
    //   quality: "",
    //   variety_type:"",
    //   type: "",
    //   color: "",
    //   sample_cut: "NO",
    //   swatch_cut: "NO",
    //   act_color: "",
    //   width: "",
    //   each_clr_mtr:0,
    //   qty: 0,
    //   mtrs: 0,
    //   rate: 0,
    //   amount: 0,
    //   no_of_clrs : 0
    //   // less_value: 0,
    // };
    // let row = Object.assign({}, this.row);
    // this.data.designList.push(row);
  }
  ngOnInit() {
    if (this.mode == "Edit") {
      setTimeout(() => {
        this.editShadeOpen = true;
      }, 1000);
    } else if (this.mode == "Add") {
      this.editShadeOpen = true;
      this.getVarietyList();
    }

    // this.styleList();
    this.tableScroll();
    if (this.mode == "Add" || this.mode == "addSample") {
      this.getAuto();
      this.getSeasonList();

      this.filter.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.designdata.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }
    this.filteredOptions = this.parentCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );

    this.getVarietyList();
    this.checkDcexist("type");
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.codeList.filter((option) =>
      option.code.toLowerCase().includes(filterValue)
    );
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  getAuto() {
    this.sampService.getAutoSampleNumber({}).then((res: any) => {
      this.filter.ref_no = res;
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];

      for (let i = res.length - 1; i > res.length - 10; i--) {
        partialSeason.push(res[i]);
      }

      let today = new Date();
      let curDate =
        today.getFullYear() +
        "-0" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      res.forEach((el) => {
        if (curDate >= el.order_from && curDate <= el.order_to) {
          this.filter.season = el.season;
        }
      });

      this.seasonList = partialSeason;
    });
  }
  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {
      let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
      }, []);
    });
  }
  checkDcexist(type) {
    this.sampService.checkDcexist(type).then((res: any) => {
      this.checklist = res.data;
      console.log(this.checklist);
    });
  }
  filteredSeriesList() {
    if (!this.seriesSearch) return this.seriesLimitsList;
    const q = this.seriesSearch.toLowerCase();
    return this.seriesLimitsList.filter(r =>
      r.style.toLowerCase().includes(q) || r.type.toLowerCase().includes(q)
    );
  }
  openSeriesLimits() {
    this.seriesLimitsLoading = true;
    this.seriesLimitsList = [];
    this.seriesSearch = '';
    $("#seriesLimitsModal").modal("show");
    this.sampService.getSeriesLimits().then((res: any) => {
      this.seriesLimitsLoading = false;
      this.seriesLimitsList = res.success ? (res.data || []) : [];
    }).catch(() => {
      this.seriesLimitsLoading = false;
    });
  }
  getStatusClass(remaining: number): string {
    if (remaining <= 10)  return 'danger';
    if (remaining <= 100) return 'warning';
    if (remaining <= 500) return 'info';
    return 'success';
  }
  OncheckCore(ind) {
    if (this.detailList[ind].style == "RR FORMAL" || this.detailList[ind].style == "RR CASUAL") {
      let params = {
        core_design: this.detailList[ind].design_no,
      };
      this.sampService.checkCoreexist(params).then((res: any) => {
        if (res.data.length > 0) {
          this.detailList[ind].shirtdno = res.data[0].core_designno;
          this.detailList[ind].sample1_no = res.data[0].variety_no;
          this.detailList[ind].sample_no = res.data[0].variety_no;

          

        } else {
          swal(params.core_design + " " + "DoesNot Exist In Core Master!");
        }
      });
    } else if (
      this.detailList[ind].type == "CLUB" &&
      this.detailList[ind].style == "FORMAL"
    ) {
      const temp = this.detailList.filter(
        (x, ind1) =>
          x.style == "FORMAL" && x.type == "CLUB" && x.shirtdno > 7379
      );
      if (temp.length > 0) {
        console.log(temp);
        const checkNan = (val) => {
          return isNaN(val) ? 0 : parseInt(val);
        };
    
        this.detailList[ind].shirtdno = checkNan(temp[temp.length-1].shirtdno) + 1;
        let t_no = checkNan(temp[temp.length-1].sample_no) +1
        this.detailList[ind].sample_no = t_no
        this.detailList[ind].sample1_no ='CB-'+ t_no
console.log(this.detailList)
      } else {
   

        for (let i in this.shirtArr) {
          console.log(i); // name, email, foo
          if (i == "CB") {
            let no = this.shirtArr[i];
           this.detailList[ind].shirtdno = 0;
           this.detailList[ind].shirtdno = no;
            console.log(this.detailList[ind].shirtdno);
         
          }
        }
        for (let i in this.sampleArr) {
          console.log(i); // name, email, foo
          if (i == "CB") {
            let samno  = this.sampleArr[i];
           this.detailList[ind].sample1_no =  'CB-'+ samno
           this.detailList[ind].sample_no = samno;


          }
        }
      }
      return false;
    } else {
      this.selectStyle(ind);
    }
  }
  refreshStyle() {
    this.Is_save = false;
    const checkNan = (val) => {
      return isNaN(val) ? 0 : parseInt(val);
    };
    const orgShirt = { ...this.shirtArr };
    const orgSamp = { ...this.sampleArr };
    
    // this.detailList.map((e, ind) => {
    //   const temp = this.detailList.find(
    //     (x, ind1) => x.style  == e.style && ind > ind1
    //   );
    //   if (temp) {
    //     //If Already Style Exist
    //     let shirtdno = checkNan(this.shirtArr[e.style+ ' ' +e.type ]) + 1;
    //     let sampleno = checkNan(this.sampleArr[e.style]) + 1;
    //     e.shirtdno = shirtdno;
    //     e.sample_no = sampleno;
    //     console.log(this.detailList);
    //     this.shirtArr[e.style+ ' ' +e.type] = shirtdno;
    //     this.sampleArr[e.style] = sampleno;

    //     e.sample1_no = this.addSamplenoPref(e.style, e.sample_no);
    //   } else {
    //     console.log("testing",this.shirtArr[e.style+ ' ' +e.type]);
    //     e.shirtdno = checkNan(this.shirtArr[e.style+ ' ' +e.type]);
    //     e.sample_no = checkNan(this.sampleArr[e.style]);
    //     e.sample1_no = this.addSamplenoPref(e.style, e.sample_no);
    //   }
    //   let temp_no = "";
    //   if (this.detailList[ind].style == "FORMAL") {
    //     temp_no = "4999";
    //   } else if (this.detailList[ind].style == "CASUAL") {
    //     temp_no = "6999";
    //   } else if (this.detailList[ind].style == "CLUBWEAR" || this.detailList[ind].style == "CLUB") {
    //     temp_no = "9999";
    //   }

    //   if (
    //     //If Limit reaches Again Its Start From The Formal-1000,Casual-5000,Club-7000 Series
    //     (e.style == "FORMAL" && e.shirtdno == 4999) ||
    //     (e.style == "CASUAL" && e.shirtdno == 6999) ||
    //     ((e.style == 'CLUB' || e.style == 'CLUBWEAR') && e.shirtdno == 9999 )
    //   ) {
    //     swal(
    //       e.style +
    //         " " +
    //         "REACHES" +
    //         '<span style = "color : red">' +
    //         " " +
    //         e.shirtdno +
    //         "</span>" +
    //         "\n MAXIMUM LIMIT" +
    //         '<span style = "color : red">' +
    //         " " +
    //         temp_no +
    //         "</span>" +
    //         "\n YOU CAN'T BE SAVED"
    //     );
    //     this.Is_save = true;
    //   }
    // });
    this.detailList.map((e, ind) => {
      const temp = this.detailList.find(
        (x, ind1) => x.style  == e.style && ind > ind1
      );
      if (temp) {
        //If Already Style Exist
        let sampleno = checkNan(this.sampleArr[e.style]) + 1;
        e.sample_no = sampleno;
        console.log(this.detailList);
        this.sampleArr[e.style] = sampleno;

        e.sample1_no = this.addSamplenoPref(e.style, e.sample_no);
      } else {
        e.sample_no = checkNan(this.sampleArr[e.style]);
        e.sample1_no = this.addSamplenoPref(e.style, e.sample_no);
      }
      let temp_no = "";
      // if (this.detailList[ind].style == "FORMAL") {
      //   temp_no = "4999";
      // } else if (this.detailList[ind].style == "CASUAL") {
      //   temp_no = "6999";
      // } else if (this.detailList[ind].style == "CLUBWEAR" || this.detailList[ind].style == "CLUB") {
      //   temp_no = "9999";
      // }
    });
    this.detailList.map((e, ind) => {
      const temp1 = this.detailList.find(
        (x, ind1) => (x.style+ ' ' +x.type)  == (e.style+ ' ' +e.type) && ind > ind1
      );
      if (temp1) {
        //If Already Style Exist
        let shirtdno = checkNan(this.shirtArr[e.style+ ' ' +e.type ]) + 1;
        e.shirtdno = shirtdno;
        console.log(this.detailList);
        this.shirtArr[e.style+ ' ' +e.type] = shirtdno;

      } else {
        console.log("testing",this.shirtArr[e.style+ ' ' +e.type]);
        e.shirtdno = checkNan(this.shirtArr[e.style+ ' ' +e.type]);
      }
      let temp_no = "";
      if (this.detailList[ind].style == "FORMAL") {
          if(this.detailList[ind].type == "CHECKS"){
            temp_no = "7999";
          }else if(this.detailList[ind].type == "STRIPES"){
            temp_no = "9999";
          }else if(this.detailList[ind].type == "PRINTS"){
            temp_no = "5999";
          }else if(this.detailList[ind].type == "PRINT"){
            temp_no = "11999";
          }else if(this.detailList[ind].type == "AADA"){
            temp_no = "12999";
          }else if(this.detailList[ind].type == "MOTIF"){
            temp_no = "12499";
          }else if(this.detailList[ind].type == "PANEL"){
            temp_no = "13999";
          }
      } else if (this.detailList[ind].style == "CASUAL") {
          if(this.detailList[ind].type == "CHECKS"){
            temp_no = "15999";
          }else if(this.detailList[ind].type == "PRINT"){
            temp_no = "16999";
          }else if(this.detailList[ind].type == "PANEL"){
            temp_no = "17999";
          }else if(this.detailList[ind].type == "AADA"){
            temp_no = "18999";
          }else if(this.detailList[ind].type == "STRIPES"){
            temp_no = "19999";
          }
      } else if (this.detailList[ind].style == "CLUB") {
        temp_no = "7999";
      } else if (this.detailList[ind].style == "CLUBWEAR") {
        temp_no = "9999";
      }

      if (
        //If Limit reaches Again Its Start From The Formal-1000,Casual-5000,Club-7000 Series
        (e.style == "FORMAL" && e.type=="CHECKS" && e.shirtdno == 7999) ||
        (e.style == "FORMAL" && e.type=="STRIPES" && e.shirtdno == 9999) ||
        (e.style == "FORMAL" && e.type=="PRINTS" && e.shirtdno == 5999) ||
        (e.style == "FORMAL" && e.type=="PRINT" && e.shirtdno == 11999) ||
        (e.style == "FORMAL" && e.type=="AADA" && e.shirtdno == 12999) ||
        (e.style == "FORMAL" && e.type=="MOTIF" && e.shirtdno == 12499) ||
        (e.style == "FORMAL" && e.type=="PANEL" && e.shirtdno == 13999) ||
        (e.style == "CASUAL" && e.type=="CHECKS" && e.shirtdno == 15999) ||
        (e.style == "CASUAL" && e.type=="PRINT" && e.shirtdno == 16999) ||
        (e.style == "CASUAL" && e.type=="PANEL" && e.shirtdno == 17999) ||
        (e.style == "CASUAL" && e.type=="AADA" && e.shirtdno == 18999) ||
        (e.style == "CASUAL" && e.type=="STRIPES" && e.shirtdno == 19999) ||
        (e.style == "CLUB" && e.shirtdno == 7999) ||
        (e.style == 'CLUBWEAR' && e.shirtdno == 9999 )
      ) {
        swal(
          e.style +
            " " +
            "REACHES" +
            '<span style = "color : red">' +
            " " +
            e.shirtdno +
            "</span>" +
            "\n MAXIMUM LIMIT" +
            '<span style = "color : red">' +
            " " +
            temp_no +
            "</span>" +
            "\n YOU CAN'T BE SAVED"
        );
        this.Is_save = true;
      }

      // The band is already full, so no number could be issued at all. Stop here rather
      // than letting the entry spill into the next variety's range.
      if (this.fullSeries.indexOf(e.style + " " + e.type) > -1) {
        swal(
          e.style +
            " " +
            e.type +
            "\n SERIES IS FULL" +
            '<span style = "color : red">' +
            " " +
            temp_no +
            "</span>" +
            "\n YOU CAN'T BE SAVED"
        );
        this.Is_save = true;
      }
    });
    this.shirtArr = orgShirt;
    this.sampleArr = orgSamp;
  }

  addSamplenoPref(style, sampleno) {
    let prefix = "";
    if (style == "FORMAL") {
      prefix = "FL-";
    } else if (style == "CASUAL") {
      prefix = "CL-";
    } else if (style == ("CLUBWEAR" || "CLUB WEAR")) {
      prefix = "CW-";
    } else if (style == ("STYLISH FORMAL" || "STYLISHFORMAL")) {
      prefix = "SF-";
    }
    else if (style == "CLUB") {
      prefix = "CB-";
    }
    return prefix + sampleno;
  }

  checkDcNo(type) {
    let checkArr = [];
    //  let empArr = [];
    checkArr = this.checklist;
    let data = [];
    data = this.seasonList;
    let temp = data.filter((o) => o.season == this.filter.season);
    let currentSeasonId = temp.length > 0 ? temp[0].season_id : null;
    let check = checkArr.find((o) => o.dc_no == type && o.season_id == currentSeasonId);
    if (check) {
      console.log(check);
      swal("Given DC NO Already Entered!");
      return;
    }
    //  console.log(temp);
    //  console.log(type);

    temp[0]["order_from"] = this.datePipe.transform(
      temp[0]["order_from"],
      "yyyy-MM-dd"
    );

    temp[0]["order_to"] = this.datePipe.transform(
      temp[0]["order_to"],
      "yyyy-MM-dd"
    );
    let params = {
      dc_no: type,
      order_from: temp[0]["order_from"],
      order_to: temp[0]["order_to"],
    };

    this.sampService.getSampleDetails(params).then((res: any) => {
      res.data.forEach((el) => {
        this.shirtArr[el.style] = this.shirtArr[el.style]
          ? this.shirtArr[el.style] > el.shirtdno
            ? el.shirtdno
            : this.shirtArr[el.style]
          : el.shirtdno;

        this.sampleArr[el.style] = this.sampleArr[el.style]
          ? this.sampleArr[el.style] > el.sample1_no
            ? el.sample1_no
            : this.sampleArr[el.style]
          : el.sample1_no;
      });

      // this.detailpreList = [...res.data];
      this.detailpreList = JSON.parse(JSON.stringify(res.data));

      this.detailList = res.data;
      let design_cnt = 0;
      let des_clr = 0;
      for (let i = 0; i < this.detailList.length; i++) {
        des_clr += Number(this.detailList[i].tot_clrs);
        design_cnt++;
      }
      this.designdata.colorCount = des_clr;
      this.designdata.designCount = design_cnt;

      this.sampleArr = res.sampleArr;
      this.shirtArr = res.shirtArr;
      // style+variety whose reserved number band is exhausted - no number can be issued
      this.fullSeries = res.fullSeries || [];
      this.refreshStyle();
      // this.detailpreList.push(this.detailList);
      // this.detailpreList = [...this.detailList];

      //     for(var i = 0; i < this.detailList.length ; i++){
      //       let val = this.detailList[i].style;
      //  let index = this.samplePrefixList.findIndex(el => el.style == val);
      //   this.detailList[i].style = this.samplePrefixList[index].prefix + this.detailList[i].style;

      //     }
      if (this.detailList.length == 0) {
        swal("Given DC NO Does Not Exist This Season!");
      }
    });
  }
  selectStyle(type) {
if(type== 0){
  type = 1;
}
if(this.detailList[type-1].style == "FORMAL" && this.detailList[type-1].type == "CLUB"){
  return
}
else{
    this.refreshStyle();

}
    // return;

    // let ind = type;
    // let val = [];
    // let val2 = [];
    // let temp = [];

    // val = this.detailpreList;

    // let style = this.detailList[ind]['style'];

    // var res = style;
    // val.forEach((element) => {
    //   if (res == element.style) {
    //     temp.push(element.sample1_no);
    //     val2.push(element.shirtdno);

    //   }
    // });

    // console.log(temp);

    // var maximum = Math.max.apply(Math, temp.map(o => o));
    // console.log(maximum);
    // var max = Math.max.apply(Math, val2.map(o => o));
    // console.log(max);
    // if (max > 0) {
    //   let tempstyle = this.detailpreList[ind].style
    //   let shirtdno = this.detailList[ind]['shirtdno'];
    // let sample_no = this.detailList[ind]['sample1_no'];

    // this.detailList.forEach((element) => {
    //   if (tempstyle == element.style) {
    //    if(shirtdno < element.shirtdno)
    //    element.shirtdno = element.shirtdno - 1;
    //   }
    //   if(sample_no < element.sample1_no){
    //      element.sample1_no - 1;
    //      element.sample_no  = element.sample1_no - 1;
    //      element.sample1_no  = element.sample1_no - 1;

    //   }

    // });

    //   let prefix = ''
    //   if (style == 'FORMAL') {
    //     prefix = 'FL-';
    //   }
    //   else if (style == 'CASUAL') {
    //     prefix = 'CL-';
    //     console.log(prefix);
    //   }
    //   else if (style == ('CLUBWEAR' || 'CLUB WEAR')) {
    //     prefix = 'CB-';
    //   }
    //   else if (style == ('STYLISH FORMAL' || 'STYLISHFORMAL')) {
    //     prefix = 'SF-';
    //   }
    //   this.detailList[ind]['shirtdno'] = max + 1;
    //   this.detailList[ind]['sample_no'] = prefix + (maximum + 1);
    //   this.detailList[ind]['sample1_no'] = maximum + 1;
    // }
    // else {
    //   let params = {
    //     style: style
    //   }
    //   this.sampService.getshirtSampleNo(params).then((res: any) => {

    //     this.detailList[ind]['shirtdno'] = res.data[0].shirtdno;
    //     this.detailList[ind]['sample_no'] = res.data[0].sample_no;

    //   });
    // }
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.codeList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_name: id });
      this.designdata.party_id = fitem["party_id"];
      return fitem["party_name"];
    }
    return "";
  }
  loadeditdesignlist(id) {
    let params = {
      id: id,
    };
    this.sampService.getInwDetails(params).then((res: any) => {
      this.detailList = res.data;
      let designCount = 0;
      let clrCount = 0;
      for (let i = 0; i < this.detailList.length; i++) {
        // debugger;(+num1) + (+num2)
        clrCount += Number(this.detailList[i].tot_clrs);
        designCount++;
      }
      this.designdata.colorCount = clrCount;
      this.designdata.designCount = designCount;
    });
  }
  addSample() {
    this.filter.date = this.datePipe.transform(this.filter.date, "yyyy-MM-dd");
    let that = this;

    let params: any = Object.assign({}, this.filter);
    params["data"] = JSON.stringify(this.detailList);

    swal({
      title: "Are you sure to save this Sample?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      // that.detailList.sample_no = that.sampledata.sample_prefix+that.sampledata.sample_no;

      //  params["data"] = JSON.stringify(this.detailList);
      //  params["details"] = JSON.stringify(this.filter);
      // that.isLoading = true;
      that.sampService.addSampleInward(params).then(function (res: any) {
        if (res == false) {
          swal("Please Enter Dc First");
        } else {
          let tabObj = {
            action: "CloseTab",
            params: {},
          };

          that.tabUpdateEvent.emit(tabObj);
          that.saveEvent.emit(tabObj);

          // that.sampledata = {
          //     sample_no: '',
          //     fab_design_no: '',
          //     tot_colors: '',
          //     brand: '',
          //     style: '',
          //     dc_no: '',
          //     season: ''
          // }
          // that.sampledata.sample_no = "";
          // that.sampledata.fab_design_no = "";
          // that.sampledata.tot_colors = "";
          // that.sampledata.brand = "";
          // that.sampledata.style = "";
          // that.sampledata.dc_no = "";
          // that.sampledata.mtrs = 0;
          // that.sampledata.type = "";
          // that.sampledata.sample_prefix = "";
          //      that.sampledata.season = that.invoiceData[0].season;
        }
      });
    });
  }

  // onSaveOrder() {
  //          params["data"] = JSON.stringify(this.detailList);
  //   params["date"] = this.datePipe.transform(
  //     this.returndata.date,
  //     "yyyy-MM-dd"
  //   );
  //   params["ret_date"] = this.datePipe.transform(
  //     this.returndata.ret_date,
  //     "yyyy-MM-dd"
  //   );
  //     let that = this;
  //     that.isLoading = true;
  //     if (that.mode == "Add") {
  //       swal({
  //         title: "Are you sure to save this Return Bundle Details?",
  //         type: "warning",
  //         showCancelButton: true,
  //         confirmButtonText: "Yes, save it!",
  //         cancelButtonText: "No, want to change",
  //       }).then(function () {
  //         that.isLoading = true;
  //         that.salesservice
  //           .addSalesBundleRtn(params)
  //           .then(function (res: any) {
  //             that.isLoading = false;
  //             if (that.saveEvent) {
  //               that.saveEvent.emit();
  //             }
  //             if (res.success) {
  //               //    that.printdata(res.printData);
  //               that.toasterService.pop({
  //                 bodyOutputType: 1,
  //                 type: "success",
  //                 title: "SUCCESS",
  //                 body: res.message,
  //               });
  //               if (that.mode == "Add") {
  //                 let tabObj = {
  //                   action: "CloseTab",
  //                   params: {},
  //                 };
  //                 that.tabUpdateEvent.emit(tabObj);
  //               } else {
  //                 let tabObj = {
  //                   action: "CloseTab",
  //                   params: {},
  //                 };
  //                 that.tabUpdateEvent.emit(tabObj);
  //               }
  //             } else {
  //               swal("ERROR", res.message, "error");
  //             }
  //           })
  //           .catch(function (error: any) {
  //             that.isLoading = false;
  //             let res = JSON.parse(error._body);
  //             swal("ERROR", res.message, "error");
  //           });
  //       });
  //     }
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/AddEditcreateSample.ts